let en = {
  translations: {
    'Current Date': 'Current Date',
    'Data relating to the average performance of the period': 'Data corresponding to the average figure of the selected interval',
    'Active': 'Active',
    'Pause': 'Pause',
    'Time': 'Time',
    "map-monitoring-points": "Monitoring points map",
    'data-relating-to-the-area': 'Data corresponding to',
    'all-zones': 'All zones',
    'select-one-or-more zones': 'Select one or more zones',
    'status-of-monitoring-points': 'Monitoring points status',
    'critic': 'Critical',
    'warning': 'Warning',
    'filters': 'Filters',
    'all': 'All',
    'no-data-present': 'No data available',
    'Real-time data': 'Real time data',
    'temperature': 'Temperature',
    'gis': 'GIS',
    "map-real-time": "Real time data map",
    "map-animated": "Animated map",
    dashboard: 'Dashboard',
    home: 'Home',
    "status-sensors": "Monitoring points status",
    "Alarm list": "Alarms list",
    "data-sensors": "Sensors data",
    "global": "Global",
    "metrics": "Metrics",
    "management": "Management",
    "users": "Users",
    "monitoring-points": "Monitoring points",
    'humidity': 'Humidity',
    'illuminance': 'Illuminance',
    'rainfall-intensity': 'Rainfall Intensity',
    'Rainfall intensity': 'Rainfall intensity',

    'precipitation-peak': 'Rainfall Peak',
    'wind-speed': 'Wind Speed',
    'wind-direction': 'Wind Direction',
    'atmospheric-pressure': 'Atmospheric pressure',
    'people-counter': 'Crowdedness',
    'absent': 'Not available',
    'high-decrement': 'High Decrement',
    'stable': 'Stable',
    'variable': 'Variable',
    'average-decrease': 'Average Decrease',
    'low-decrement': 'Low Decrement',
    'high-increment': 'High Increment',
    'medium-increment': 'Medium Increment',
    'low-increment': 'Low Increment',
    'Trend of the last 60 minutes': 'Trend of the last 60 minutes',
    'Average': 'Average',
    'Minimal': 'Minimal',
    'Maxim': 'Maxim',
    'All': 'All',
    'Basic environmental monitoring': 'Basic environmental monitoring',
    'Advanced environmental monitoring': 'Advanced environmental monitoring',
    'environmental monitoring': 'Environmental monitoring',

    'Camera': 'Camera',
    'WiFi': 'WiFi',
    'Gateway': 'Gateway',
    'Filter by component type': 'Filter by component type',
    'Critical status monitoring points list': 'Monitoring points with critical status',
    'Attention status monitoring points list': 'Monitoring points with warning status',
    'Monitoring point list status OK': 'Monitoring points with Ok status',
    'Address': 'Address',
    'View Alarms': 'View Alarms',
    'Data not present': 'Data not available',
    'type': 'Type',
    'base': 'Basic',
    'advanced': 'Advanced',
    'add': 'Add',
    'Add sensor data': 'Add sensor',
    'Environmental Sensor ID': 'Environmental Sensor ID',
    'Environmental Monitoring Status': 'Environmental Monitoring status',
    'Camera status': 'Camera status',
    'Gateway status': 'Gateway status',
    'People counter status': 'Crowdedness status',
    'WiFi status': 'WiFi status',
    'Show inactive': 'Show inactive',
    'Show mutated': 'Show mutated',
    'There is no warning': 'No alarms',
    'Component type': 'Component type',
    'Severity': 'Severity',
    'Type of alarm': 'Type of alarm',
    'Component ID': 'Component ID',
    'Creation date': 'Creation date',
    'End date': 'End date',
    'Mute activated': 'Mute on',
    'Mute off': 'Mute off',
    'Name': 'Name',
    'Last name': 'Last name',
    'Enabling': 'Enabling',
    'Confirmation': 'Confirmation',
    'Role': 'Role',
    'Add new user': 'Add new user',
    'Confirm password': 'Confirm password',
    'Close': 'Close',
    'User list': 'User list',
    'Add user': 'Add user',
    'Modify user data': 'Change user data',
    'User data': 'User data',
    'Edit': 'Edit',
    'User role': 'User role',
    'User Enablement': 'User enabling',
    'Rows per page': 'Rows per page',
    'of': 'of',
    'Map monitoring points': 'Monitoring points map',
    'Base environmental station': 'Basic environmental station ',
    'Advanced environmental station': 'Advanced environmental station',
    'Rainfall': 'Rainfall',
    'Intensity': 'Intensity',
    'Peak': 'Peak',
    'Wind': 'Wind',
    'Speed': 'Speed',
    'Direction': 'Direction',
    'Last 24 hours': 'Last 24 hours',
    'Select the date': 'Select the date',
    'Start date and time': 'Start date and time',
    'End date and time': 'End date and time',
    'Animated historical map': 'Animated historical map',
    'Now': 'Now',
    'Data relating to': 'Data corresponding to',
    'Data not available for selected options': 'Data not available with the selected options',
    'No data for selected filters': 'No data with the selected filters',
    'Wind speed and direction': 'Wind speed and direction',
    'Number of person': 'Number of people',
    'Confirmed': 'Confirmed',
    'Not confirmed': 'Not confirmed',
    'Enabled': 'Enabled',
    'Not Enabled': 'Not Enabled',
    'Updated to': 'Last update',
    'All monitoring points': 'All monitoring points',
    'Select the station': 'Select the monitoring point',
    'Elimination': 'Delete',
    'Are you sure you want to proceed with the deletion?': 'Are you sure you want to proceed?',
    'Yes': 'Yes',
    'Monitoring points list': 'Monitoring points list',
    'Add station': 'Add station',
    'Connectivity type': 'Connectivity type',
    'Add new monitoring point': 'Add new monitoring point',
    'Add monitoring point': 'Add monitoring point',

    'Station ID': 'Monitoring point ID',
    'Latitude': 'Latitude',
    'Longitude': 'Longitude',
    'Description': 'Description',
    'Environment monitoring': 'Environment monitoring',
    'Type of environmental monitoring': 'Type of environmental monitoring',
    'Camera address': 'Camera address',
    'WiFi address': 'WiFi address',
    'People counter sensor': 'Crowdedness sensor',
    'Gateway ID': 'Gateway ID',
    'Serial Gateway': 'Gateway Serial',
    'Gateway address': 'Gateway IP address',
    'Gateway MAC': 'Gateway MAC',
    'Gateway internal address': 'Gateway internal IP address',
    'Add Sensor': 'Add Sensor',
    'Edit People Counter Sensor ID': 'Edit Crowdedness Sensor ID',
    'Sensor ID': 'Sensor ID',
    'Select the Metric': 'Select the Metric',
    'Air quality': 'Air quality',
    'Pressure': 'Pressure',
    'hour': 'Hour',
    'Humidity-percentage': 'Humidity (%)',

    'addData': 'Add data',
    'addFilter': 'Add Filter',
    'addLayer': 'Add Layer',
    'rowCount': 'Rows',

    'show animation': 'Show Animation',
    'Component': 'Component',
    'Details Environmental Sensor': 'Environmental Sensor Details',
    'Component status': 'Component status',
    "No monitoring points in ok status": "No monitoring points in ok status",
    "No monitoring points in alert state": "No monitoring points in warning state",
    "No monitoring points in critical state": "No monitoring points in critical state",
    "Date Validity": "Date Validity",
    'ID copied': 'ID copied',
    'Modify data': 'Change details of',
    'Status': 'Status',
    'Inactive': 'Inactive',
    'Deactivate': 'Deactivate',
    'Activate': 'Activate',
    'Model': 'Model',
    'Sending interval': 'Send interval',
    'seconds': 'seconds',
    'AWS ID': 'AWS ID',
    'Internal address': 'Internal IP address',
    'Serial': 'Serial',
    'Optic fiber': 'Optical fiber',
    'years': 'years',
    'None': 'None',
    'Enter your email address to receive the reset link': 'Enter your email address to receive the password reset link',
    "Forgot password?": "Forgot password?",
    'Do you already have an account?': 'Do you already have an account?',
    'Welcome': 'Welcome',
    "Enter your credentials to continue": "Enter your credentials to continue",
    'Account settings': 'Account Settings',
    'Send email': 'Send email',
    'Change Password': 'Change Password',
    'Enter the new password': 'Enter the new password',
    'An Error has occurred': 'An Error has occurred',
    'Confirm registration': 'Confirm registration',
    "Failed to complete registration, invalid token!": "Failed to complete registration, invalid token!",
    "temperature_celsius": "Temperature (°C)",
    'Atmospheric_pressure_symbol': 'Atmospheric pressure (hPa)',
    'People': 'People',
    'Sensors ID': 'Sensors ID',
    'W': 'W ',
    'WSW': 'WSW',
    'WNW': 'WNW',
    'NW': 'NW',
    'NNW': 'NNW',
    'SW': 'SW',
    'SSW': 'SSW',
    'Average direction': 'Average direction',
    'Average speed': 'Average speed',
    'absent-wind': 'Calm',
    'Absent data': 'Not available',
    'Version': 'Version',
    'Threshold of attention': 'Warning threshold',
    'Historical data': 'Historical data',
    'today': 'Today',
    'month': 'Month',
    'Select date': 'Select date',
    'Y Axis': 'Y Axis',
    'Moving Time Window': 'Moving Time Window',
    'Search': 'Search',
    'User profile': 'User profile',
    'Security': 'Security',
    'Profile Settings': 'Profile Settings',
    'Password required': 'Password required',
    'Passwords do not match': 'Passwords do not match',
    'Confirm password required': 'Confirm password required',
    'Email required': 'Email required',
    'Please enter a valid email': 'Please enter a valid email',
    'Role required': 'Role required',
    'Required address': 'Address required',
    'Latitude required': 'Latitude required',
    'Longitude required': 'Longitude required',
    'Cluster required': 'Cluster required',
    'Sensor required': 'Sensor required',
    'Camera required': 'Camera required',
    'Gateway id required': 'Gateway ID required',
    'Sensor id required': 'Sensor ID required',
    'Model required': 'Model required',
    'Id People Counter Sensor': 'Crowdedness Sensor ID',
    'Login': 'Login',
    'Management of environmental monitoring network and anthropic load': 'Management of the environmental and crowdedness monitoring network',
    'Light': 'Light',
    'Mode': 'Mode',
    'Dark': 'Dark',
    'Preset Color': 'Color Preset',
    'Live Customize': 'Live Customize',
    'Download the Archive': 'Download the Archive',
    'with data relating to the monitoring point, taken every 10 minutes.': 'with the data of the selected day taken every 10 minutes, divided by monitoring point',
    'Selected date': 'Selected date',
    'Download': 'Download',
    'No date selected': 'No date selected',
    'Archive not available for the selected day': 'Data not available for the current selection',
    'Confirm user': 'Confirm user',
    'Monitoring point management': 'Monitoring point management',
    'CO2 level': 'CO2 Level',
    'PM 10 Level': 'PM 10 Legal Limits',
    "PM 2.5 Level": "PM 2.5 Legal Limits",
    "Heat Wave": "Heat Wave",
    'Days': 'Days',
    'Previous day': 'Previous day',
    'no hot wave': 'No hot wave',
    'short wave': 'short wave',
    'long wave': 'long wave',
    'In progress': 'In progress',
    'Not in progress': 'Not in progress',
    'Annual average': 'Annual average',
    'Data not available': 'Data not available',
    'Acceptable': 'Acceptable',
    'Annual data': 'Annual data',
    'Previous day data': 'Previous day data',
    "Stats not available with 2 or more zones selected": "Insights not available with 2 or more zones selected",
    "Stats not available with 2 or more zones selected and no station": "Insights not available with 2 or more zones and no monitoring point selected",
    'Days with critical CO2 level': 'Days with critical CO2 level',
    'Heat wave days': 'Heat wave days',
    'Number waves': 'Number of waves',
    'waves': 'waves',
    'Legal limit': 'Legal limit',
    'Not passed': 'Not exceeded',
    'Passed': 'Exceeded',
    'OMS threshold': 'OMS threshold',
    'Daily Limit': 'Daily Limit',
    'from': 'from',
    'Not passed fem': 'Not exceeded',
    'Passed fem': 'Exceeded',
    'Average day': 'Day average',
    'Maximum day': 'Day maximum',
    'pers.': 'peop.',
    ' pers.': ' peop.',
    'Hardware Version': 'Hardware Version',
    'Software Version': 'Software Version',
    'Present': 'Available',
    'Select Month': 'Select Month',
    'Select Year': 'Select Year',
    'Select Year and Month': 'Select Year and Month',
    'Download the archive containing the data collected every 10 minutes, divided by monitoring point': 'Download a zip archive with the collected data at 10 minutes intervals, split by monitoring point',
    'Daily archive': 'Daily Archive',
    'Monthly Archive': 'Monthly Archive',
    'unknown': 'unknown',
    'No Options': 'No Options',
    'Play': 'Play',
    'Incremental Time Window': 'Incremental Time Window',
  },
};

export default en;
